import { Dimensions, StyleSheet } from "react-native";

const styles = StyleSheet.create({
    progressBarContainer: {
        width: '80%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 30,
        alignItems: 'center'
    },
    progressBarTitle: {
        fontSize: 20,
        fontFamily: 'Montserrat_400Regular',
        marginBottom: 10
    },
    progressBar: {
        backgroundColor: '#eee',
        height: 20,
        width: '100%',
        borderRadius: 10
    },
    currentProgress: {
        borderRadius: 10,
        backgroundColor: '#56F07D',
        height: '100%'
    },
    currentProgressText: {
        fontSize: 18,
        fontFamily: 'Montserrat_400Regular',
    },
    fullProgressText: {
        fontSize: 18,
        fontFamily: 'Montserrat_400Regular',
        marginLeft: 'auto',
    },

});

export default styles;